import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CompanyHero from './components/CompanyHero';
import CompanyInfo from './components/CompanyInfo';
import Philosophy from './components/Philosophy';
import Representative from './components/Representative';

export default function Company() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CompanyHero />
      <CompanyInfo />
      <Philosophy />
      <Representative />
      <Footer />
    </div>
  );
}
